module.exports = __webpack_public_path__ + "static/media/icon-list.8ce00c9e.svg";